// src/Routes/allRoutes.tsx

import { Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
// import CrmContacts from "pages/Contact";
import Login from "../pages/Login";
import User from "../pages/user";
import Glossary from "pages/glossary";
import Guides from "pages/guide";
import FluentBlog from "../pages/fluentBlog";
// import Lead from "pages/lead";
// import ViewDocument from "pages/ViewDocument";
// import FileUpload from "pages/FileUpload";
// import UrlListing from "pages/UrlListing";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  // { path: "/contact", component: <CrmContacts /> },
  { path: "/blogs", component: <User /> },
  { path: "/fluent-blog", component: <FluentBlog /> },
  { path: "/glossary", component: <Glossary /> },
  { path: "/guides", component: <Guides /> },
  // { path: "/lead", component: <Lead /> },
  // { path: "/contact/:id/document", component: <ViewDocument /> },
  { path: "/index", component: <Dashboard /> },
  // { path: "/url-listing", component: <UrlListing /> },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  // { path: "/upload-document", component: <FileUpload /> },
];

export { authProtectedRoutes, publicRoutes };
